import { freeze } from '@reduxjs/toolkit';

export const NEW_DASHBOARD_SETTINGS = freeze(
  {
    key: 'ADD_NEW_DASHBOARD',
    optionLabel: 'Add to New Dashboard',
    menuLabel: 'New Untitled Dashboard',
  },
  true,
);
